module.exports = __webpack_public_path__ + "img/position_reset2.7e35a030.png";